var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 13.1602V3.1744C3.00781 2.24116 3.76435 1.48462 4.69759 1.48462H9.57082C10.0856 1.48462 10.5724 1.7193 10.8929 2.1221L12.959 4.71799C13.1971 5.01708 13.3267 5.38804 13.3267 5.77029V13.1602C13.3267 14.0934 12.5702 14.85 11.6369 14.85H4.6976C3.76435 14.85 3.00781 14.0934 3.00781 13.1602Z",
    stroke: "currentColor",
    strokeWidth: 0.844892
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1712 5.47501C10.1287 5.43017 10.1625 1.79075 10.1625 1.6562C10.1625 1.52165 11.8673 3.28856 11.8673 3.28856L13.0944 5.47502C13.0944 5.47502 10.2137 5.51986 10.1712 5.47501Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.563261
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17779 11.6276V6.97351M8.17779 6.97351L9.87037 8.74384M8.17779 6.97351L6.46411 8.74384",
    stroke: "currentColor",
    strokeWidth: 0.563261,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6f9e382bc19bf12edfd7f6b0b8f5df92.svg";
export { ForwardRef as ReactComponent };